import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Standard shadcn `cn` helper — combines clsx (conditional joining) with
// tailwind-merge so later utility classes win over earlier ones. Example:
// `cn("p-4", isCompact && "p-2")` resolves to just `"p-2"` when compact.
//
// Used by the brand component kit (Logo, ViewfinderFrame, …) and the UI
// primitives (Button, Badge, TimecodeChip) so consumers can pass through
// className overrides cleanly without `!important` battles.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
